import { faqs } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-28 border-t border-white/5">
    <div className="mx-auto max-w-3xl px-6">
      <Reveal className="text-center">
        <Overline>FAQ</Overline>
        <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
          Questions, <span className="text-brand-green">answered.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-white/10 bg-surface/50 px-5 !border-b"
            >
              <AccordionTrigger className="text-left text-base font-heading font-semibold text-white py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/65 text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
